var po = require('../js/public_object.js')

module.exports = {
  methods: {
    onOpenFileTaskModal: function() {
      if(po.islogin) {
        po.app.fileTaskParams = {
          mode: 'newfile',
          fileList: [],
          taskId: {},
        }
        po.app.showFileTaskModal = true
      } else {
        po.app.showLoginModal = true
      }
    }
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/menu-view.vue
// module id = 154
// module chunks = 0